<p-confirmdialog />
<p-toast />
<div class="container px-4 py-10">
  <block-ui>
    <div class="w-full p-2 m-2">
      <!-- Header Section -->
      <div class="flex items-center justify-between">
        <div class="mb-7">
          <h1 class="mb-1 text-2xl font-semibold text-primary-200">Assets</h1>
          <p class="text-sm text-primary-500">View all of Your Assets</p>
        </div>
      </div>

      <!-- Tabs -->
      <p-tabMenu
        [model]="tabs"
        [activeItem]="activeTab"
        class="mt-4 border-b"></p-tabMenu>
    </div>
    <div class="w-full p-2 m-2">
      <p-table
        #dt2
        dataKey="id"
        stripedRows
        [value]="filtered_assets"
        responsiveLayout="scroll"
        [globalFilterFields]="[
          'name',
          'asset_key',
          'asset_mac_address',
          'asset_type',
          'customerName',
          'status',
          'lastSeen'
        ]"
        [paginator]="true"
        [autoLayout]="true"
        [(selection)]="selectedAsset"
        [rows]="25"
        selectionMode="single"
        [tableStyle]="{ 'min-width': '50rem' }"
        [rowsPerPageOptions]="[25, 50, 100]">
        <ng-template #emptymessage>
          <tr>
            <td colspan="5">No assets found.</td>
          </tr>
        </ng-template>
        <ng-template #caption>
          <div class="flex">
            <p-iconfield iconPosition="left">
              <p-inputicon>
                <i class="pi pi-search"></i>
              </p-inputicon>
              <input
                pInputText
                class="w-full ml-10"
                type="text"
                (input)="filter($event, dt2)"
                placeholder="Search keyword" />
            </p-iconfield>
            <p-button
              class="ml-auto"
              label="Clear"
              [outlined]="true"
              icon="pi pi-filter-slash"
              (click)="clear(dt2)" />
                <p-button
                  icon="pi pi-external-link"
                  label="Export"
                  (click)="dt2.exportCSV()" />
              </div>
        </ng-template>

        <!-- Table Header -->
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th pSortableColumn="name">
              Name
              <p-sortIcon field="name" />
            </th>
            <th pSortableColumn="asset_mac_address">
              Mac Address
              <p-sortIcon field="asset_mac_address" />
            </th>
            <th pSortableColumn="asset_type">
              Model
              <p-sortIcon field="asset_type" />
            </th>
            <th pSortableColumn="customerName">
              Assigned
              <p-sortIcon field="customerName" />
            </th>
            <th pSortableColumn="status">
              Status
              <p-sortIcon field="status" />
            </th>
            <th pSortableColumn="lastSeen">
              Last Seen
              <p-sortIcon field="lastSeen" />
            </th>
            <th pSortableColumn="updatedAt">
              Updated At
              <p-sortIcon field="updatedAt" />
            </th>
            <th></th>
          </tr>
        </ng-template>

        <!-- Table Body -->
        <ng-template pTemplate="body" let-rowData>
          <tr [pSelectableRow]="rowData">
            <td>
              {{ rowData.name }}
            </td>
            <td>
              {{ rowData.asset_mac_address }}
            </td>
            <td>
              {{ rowData.asset_type }}
            </td>
            <td>
              {{ rowData.customerName }}
            </td>
            <td>
              <span
                [ngClass]="
                  rowData.status === 'active'
                    ? 'green'
                    : rowData.status === 'disabled'
                    ? 'orange'
                    : 'red'
                ">
                {{ rowData.status }}
              </span>
            </td>
            <td>
              {{ rowData.lastSeen | date : "short" }}
            </td>
            <td>
              {{ rowData.updatedAt | date : "short" }}
            </td>
            <td>
              <p-button
                (click)="activeItem = rowData; menu.toggle($event)"
                icon="pi pi-ellipsis-v" />
            </td>
          </tr>
        </ng-template>
      </p-table>
      <p-menu appendTo="body" #menu [model]="items" [popup]="true" />
    </div>
  </block-ui>
  <p-dialog
    header="Assign Asset"
    [modal]="true"
    [(visible)]="visible"
    [style]="{ width: '40rem' }">
    <span class="block mb-8 p-text-secondary">
      Assign subscription to this asset.
    </span>
    <div class="flex flex-wrap items-center w-full gap-4 mb-4">
      <label for="subscription" class="w-4/12 font-semibold md:w-full">
        Subscription
      </label>
      <p-autocomplete
        id="subscription"
        class="w-8/12 md:w-full"
        appendTo="body"
        [(ngModel)]="selectedSubscription"
        optionLabel="name"
        [suggestions]="filteredSubscriptions"
        (completeMethod)="searchSubscriptions($event)">
        <ng-template let-subscription #item>
          <div class="flex flex-wrap w-full">
            <div class="w-full p-2 m-2 md:8/12 top-2">
              {{ subscription.customer_id?.name }}
            </div>
            <div class="w-full p-2 m-2 md:4/12">{{ subscription.name }}</div>
          </div>
        </ng-template>
      </p-autocomplete>
    </div>
    <div class="flex justify-end gap-2">
      <p-button label="Cancel" severity="secondary" (click)="visible = false" />
      <p-button label="Save" (click)="assignAsset()" />
    </div>
  </p-dialog>
</div>
